<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Phone Model</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">Create</el-button>
          <el-button type="default" @click="cancelOperation"> Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="Config" name="Config">
          <el-input placeholder="Enter name" v-model="createForm.name">
            <template slot="prefix">Name</template>
          </el-input>

          <h2 class="form-section-header">Config request</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter XML phone configuration"
            v-model="createForm.mac"
          />

          <h2 class="form-section-header">Directory request</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter XML directory configuration"
            v-model="createForm.directory"
          />
        </el-tab-pane>
        <el-tab-pane label="Provisioning" name="Provisioning">
          <h2 class="form-section-header">Remote provisioning POST message</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter remote provisioning POST message"
            v-model="createForm.remotePost"
          />
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                placeholder="Enter provisioning URL"
                v-model="createForm.remotePostUrl"
              >
                <template slot="prefix">URL</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
          </div>
          <div class="inline-form-group">
            <el-col :span="12">
              <el-input
                placeholder="Enter provisioning user"
                v-model="createForm.remotePostUser"
              >
                <template slot="prefix">User</template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="11">
              <el-input
                placeholder="Enter provisioning password"
                v-model="createForm.remotePostPassword"
              >
                <template slot="prefix">Password</template>
              </el-input>
            </el-col>
          </div>
          <h2 class="form-section-header">Remote deregister POST message</h2>
          <el-input
            type="textarea"
            :rows="12"
            placeholder="Enter remote provisioning POST message"
            v-model="createForm.remotePostDeregister"
          />
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "PhoneModelCreateForm",

  props: {
    createVisible: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true }
  },

  data() {
    return {
      activeTab: 'Config',
      createForm: {
        name: '',
        mac: '',
        directory: '',
        remotePost: '',
        remotePostUrl: '',
        remotePostUser: '',
        remotePostPassword: '',
        remotePostDeregister: ''
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    createOperation() {
      this.$emit("createOperation", this.createForm);
    },

    validateXml(xmlStr, title) {
      if (!xmlStr) return true;

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlStr, "text/xml");

      if (xmlDoc.querySelectorAll("parsererror").length > 0) {
        // ⭐️ Notify User ⭐️ //
        this.$notify({
          title: `Invalid XML for ${title}.`,
          message: "Please enter a valid XML string.",
          type: "error"
        });
        return false;
      }
      return true;
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      Object.keys(this.createForm).forEach(key => {
        this.createForm[key] = "";
      });
      this.activeTab = 'Config';
    }
  }
};
</script>

<style lang="scss" scoped>

.el-tabs{
  max-width: 600px;
  margin: auto;
}

</style>
